export const DIMENSION_MAX_WIDTH_CM = 200;
export const DIMENSION_MAX_WIDTH_INCHES = 78.74;
export const DIMENSION_MIN_BAGS_HEIGHT_CM = 2.54;
export const DIMENSION_MIN_BAGS_HEIGHT_INCHES = 1;

export const DIMENSION_MIN_WIDTH_CM = 10;
export const DIMENSION_MIN_WIDTH_INCHES = 3.93701;

export const WEIGHT_MAX_KG = 1994;
export const WEIGHT_MAX_LB = 4400;
export const BAGS_WEIGHT_MAX_KG = 36.2874;
export const BAGS_WEIGHT_MAX_LB = 80;

export const PALLET_MAX_WIDTH_CM = 150;
export const PALLET_MAX_WIDTH_INCHES = 59.05;

export const PALLET_MAX_HEIGHT_CM = 15.24;
export const PALLET_MAX_HEIGHT_INCHES = 6;

export const PALLET_MIN_WIDTH_CM = 60.96;
export const PALLET_MIN_WIDTH_INCHES = 24;

export const CONVERSION_RATE = 2.54;

/**
 * Conversion rate to convert the angle of inclination for boxes that are face to face
 */
export const CONVERSION_RATE_FACE2FACE = 35;
export const CONVERSION_RATE_KG_LBS = 2.205;

export const MAX_LOAD_HEIGHT_INCHES = 110;
export const MAX_LOAD_HEIGHT_CM = MAX_LOAD_HEIGHT_INCHES * CONVERSION_RATE;

// Max overhang in inches.
export const MAX_OVERHANG_INCHES = 6;
export const MAX_OVERHANG_CM = 6 * CONVERSION_RATE;

export const MAX_OVERLAP_INCHES = 8;
export const MAX_OVERLAP_CM = 8 * CONVERSION_RATE;

